// extracted by mini-css-extract-plugin
export default {"accountFound":"AccountFound_accountFound__AtWni","title":"AccountFound_title__crSEm","boldDescription":"AccountFound_boldDescription__FJqTl"};